import type {
  WebAppConfig,
  WorkspaceNavigationPlacement,
} from '../model/types';

/** Resolves product-route chrome without coupling config to TanStack route IDs. */
export function resolveWorkspaceNavigationPlacement(
  config: WebAppConfig,
  pathname: string,
  tenantId: string,
): WorkspaceNavigationPlacement {
  const navigation = config.shell.workspaceNavigation;
  if (!navigation) return 'sidebar';

  const workspacePath = stripWorkspacePrefix(pathname, tenantId);
  for (const [routeId, placement] of Object.entries(navigation.routes ?? {})) {
    const route = findRoute(config, routeId);
    if (route && matchesPath(route.path, workspacePath)) return placement;
  }
  return navigation.default;
}

function findRoute(config: WebAppConfig, routeId: string) {
  for (const { descriptor } of config.features) {
    const route = descriptor.routes.find(
      (candidate) => candidate.id === routeId,
    );
    if (route) return route;
  }
  return undefined;
}

function stripWorkspacePrefix(pathname: string, tenantId: string): string {
  const prefix = `/w/${encodeURIComponent(tenantId)}`;
  if (!tenantId || !pathname.startsWith(prefix)) return pathname;
  const path = pathname.slice(prefix.length);
  return path || '/';
}

function matchesPath(pattern: string, pathname: string): boolean {
  const source = pattern
    .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    .replace(/:[A-Za-z][A-Za-z0-9]*/g, '[^/]+');
  return new RegExp(`^${source}/?$`).test(pathname);
}
